import BaseComponent from '../base/baseComponent';
import Swiper, { Pagination } from 'swiper';
import { MQ } from '../constants/styles';
import 'swiper/css';
import 'swiper/css/pagination';
Swiper.use([Pagination]);
export default class EditorialGrid extends BaseComponent {
    get SELECTORS() {
        return {
            context: '.editorialgrid-list',
            list: '.editorialgrid-content',
            slide: '.editorialgriditem',
            counter: {
                index: '.swiper-dots',
            },
        };
    }
    get CLASSES() {
        return {
            swiper: {
                main: 'swiper',
                list: 'swiper-wrapper',
                slide: 'swiper-slide',
            },
        };
    }
    constructor(element) {
        super(element);
        let backgroundEl = document.querySelector('.editorialgrid');
        if (!!!window.matchMedia(`(min-width: ${MQ.tabletLandscape}px)`).matches) {
            // if mobile
            this.swiperHandler();
        }
    }
    swiperHandler() {
        this._el.classList.add(this.CLASSES.swiper.main);
        this._el.querySelector(this.SELECTORS.list).classList.add(this.CLASSES.swiper.list);
        this._el.querySelectorAll('.editorialgrid-content > .experience-component').forEach((slide) => {
            slide.classList.add(this.CLASSES.swiper.slide);
        });
        const swiper = new Swiper(this._el, {
            modules: [Pagination],
            slidesPerView: 1,
            loop: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
        });
    }
}
